import { Tooltip } from "~/components/reusable/Tooltip"
import { type FilterGate } from "~/utils/filter"

export const GateToggle = ({
  gate,
  onToggle,
  readOnly = false,
}: {
  gate: FilterGate
  onToggle?: () => void
  readOnly?: boolean
}) => {
  if (readOnly) {
    return (
      <span className="label-base uppercase text-fg-subtle px-1.5 py-0.5 shrink-0">{gate}</span>
    )
  }
  return (
    <Tooltip title={`Switch to ${gate === "and" ? "OR" : "AND"}`}>
      <button
        type="button"
        onClick={onToggle}
        className="label-base uppercase text-fg-subtle hover:bg-component-hover rounded-md border border-dashed border-strong px-1.5 py-0.5 cursor-pointer shrink-0"
      >
        {gate}
      </button>
    </Tooltip>
  )
}
